export default {
  name: [],
  description: [],
  zone: [],
  isRelease: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
}
